
import * as React from "react"
import { Avatar as ShadcnAvatar, AvatarImage as ShadcnAvatarImage, AvatarFallback as ShadcnAvatarFallback } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

export interface EnhancedAvatarProps extends React.ComponentPropsWithoutRef<typeof ShadcnAvatar> {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const EnhancedAvatar = React.forwardRef<HTMLSpanElement, EnhancedAvatarProps>(
  ({ className, children, style, ...props }, ref) => {
    return (
      <ShadcnAvatar 
        ref={ref} 
        className={cn(className)} 
        style={style}
        {...props}
      >
        {children}
      </ShadcnAvatar>
    );
  }
);
EnhancedAvatar.displayName = "EnhancedAvatar";

export interface EnhancedAvatarImageProps extends React.ComponentPropsWithoutRef<typeof ShadcnAvatarImage> {
  src: string;
  alt?: string;
  className?: string;
  onLoad?: () => void;
  onError?: () => void;
}

export const EnhancedAvatarImage = React.forwardRef<HTMLImageElement, EnhancedAvatarImageProps>(
  ({ src, alt, className, onLoad, onError, ...props }, ref) => {
    return (
      <ShadcnAvatarImage
        ref={ref}
        src={src}
        alt={alt || ''}
        className={cn(className)}
        onLoadingStatusChange={(status) => {
          if (status === 'loaded' && onLoad) onLoad();
          if (status === 'error' && onError) onError();
        }}
        {...props}
      />
    );
  }
);
EnhancedAvatarImage.displayName = "EnhancedAvatarImage";

export interface EnhancedAvatarFallbackProps extends React.ComponentPropsWithoutRef<typeof ShadcnAvatarFallback> {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const EnhancedAvatarFallback = React.forwardRef<HTMLSpanElement, EnhancedAvatarFallbackProps>(
  ({ className, children, style, ...props }, ref) => {
    return (
      <ShadcnAvatarFallback 
        ref={ref} 
        className={cn(className)} 
        style={style}
        {...props}
      >
        {children}
      </ShadcnAvatarFallback>
    );
  }
);
EnhancedAvatarFallback.displayName = "EnhancedAvatarFallback";

// Re-export with proper names
export const Avatar = EnhancedAvatar;
export const AvatarImage = EnhancedAvatarImage;
export const AvatarFallback = EnhancedAvatarFallback;
